import { useEffect } from "react";
import { _ROUTES } from "../../../utils/_routes_constants";
import { DataTable } from "../../ui/DataTable";
import { buildIRI } from "../../../utils/function";
import { useBudgetData } from "../../../hooks/useBudgetData";
import { convertBackendDataToRows } from "../../../utils/AgGridUtils/convertBackendDataToRows";

export const TableFleetOptimisation = ({
  rows,
  setRows,
  params,
  isDataLoading,
  onDataLoadingStart,
  onDataLoadingStop,
  gridRef,
}) => {
  const { loadData, handleCellValueChanged } = useBudgetData({
    setRows,
    onDataLoadingStart,
    onDataLoadingStop,
    params,
    formDataToRow: (groupedData) =>
      convertBackendDataToRows(groupedData, {
        groupKey: "activityName",
        groupSubKey: "theme",
        additionalFields: {
          activityName: "activityName",
          theme: "theme",
        },
      }),
  });

  useEffect(() => {
    loadData(_ROUTES.IPT_FLEET_OPTIMISATION_GROUP);
  }, [params.activity]);

  const generateFleetOptimisationPayload = ({ colDef, data, newValue }) => {
    const field = colDef.field;
    const month = parseInt(field.replace("months.", ""));

    const payload = {
      amount: newValue,
      theme: data.theme,
      site: buildIRI("/sites", data.siteId),
      fiscalMonth: month,
      fiscalYear: params.fiscalYear,
      version: params.version || 1,
    };

    if (data.fiscal_month_id_mapping && data.fiscal_month_id_mapping[month]) {
      payload.id = data.fiscal_month_id_mapping[month];
    }

    return payload;
  };

  const handleCellChange = (agParams) => {
    handleCellValueChanged(
      agParams,
      generateFleetOptimisationPayload,
      _ROUTES.IPT_FLEET_OPTIMISATION,
    );
  };

  return (
    <DataTable
      isDataLoading={isDataLoading}
      rows={rows}
      gridRef={gridRef}
      columnsIncludeMonths={true}
      columns={[
        {
          headerName: "",
          field: "activityName",
          hide: true,
          rowGroup: true,
          suppressHeaderMenuButton: true,
        },
        {
          headerName: "",
          field: "theme",
          hide: true,
          rowGroup: true,
          suppressHeaderMenuButton: true,
        },
        {
          headerName: "",
          field: "site",
          showRowGroup: "activityName",
          minWidth: 200,
          suppressHeaderMenuButton: true,
        },
      ]}
      columnsAfterMonths={[
        {
          headerName: "Total",
          headerClass: "total-header-col",
          field: "total",
          editable: false,
          cellDataType: "number",
          valueFormatter: (params) => {
            if (!params || !params.data || !params.data.months) {
              return 0;
            }

            const total = Object.values(params.data.months).reduce(
              (acc, curr) => acc + curr,
              0,
            );
            return total;
          },
        },
      ]}
      onCellValueChanged={handleCellChange}
      agGridProps={{
        groupDisplayType: "groupRows",
        getRowStyle: (params) => {
          if (params.data === undefined) {
            return { backgroundColor: "#D3D3D3" };
          }
        },
      }}
    />
  );
};
